import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import "../../styles/AddUsers.scss";
import { FileStatus, ErrorButtonActionType } from "../../type/FileStatusType";
import { updateBreadcrum } from "../../redux/reducers/BreadcrumbSlice";
import { useAppDispatch } from "../../redux/hooks";
import { PAGE } from "../../constants/page";
import UploadCSVError from "../../components/admin/UploadCSVError";
import UploadCSVSuccess from "../../components/admin/UploadCSVSuccess";
import UploadInProgress from "../../components/admin/UploadInProgress";
import UploadCSV from "../../components/admin/UploadCSV";
import UploadCSVSubmit from "../../components/admin/UploadCSVSubmit";
import AuthService from "../../services/AuthService";
import { API } from "../../constants/api";
import HttpService from "../../services/HttpService";
import Utility from "../../utility/Utility";
import { Trans } from "react-i18next";
import i18next from "i18next";
import { useAppSelector } from "../../redux/hooks";
import { UserState } from "../../redux/reducers/UserSlice";
import { errorUpdate } from "../../redux/reducers/LoaderSlice";

const AddUsers = () => {
  const dispatch = useAppDispatch();
  const httpService = HttpService.instance;
  const location = useLocation();
  const userId: string = location.pathname.split("/").pop() || "";
  const [fileStatus, setFileStatus] = useState<FileStatus>(FileStatus.INIT);
  const [fileDetails, setFileDetails] = useState<null | File>(null);
  const [errorData, setErrorData] = useState({});
  const [apiErrorList, setApiErrorList] = useState([]);
  const [bulkJobDetails, setBulkJobDetails] = useState<any>({
    status: "initial",
    id: "",
  });
  const [auth0ErrorList, setAuth0ErrorList] = useState<any>([]);
  const [intervalId, setIntervalId] = useState<any>();
  const userDetails: any = useAppSelector(UserState);
  const state = userDetails?.userDetails?.user_metadata?.address?.region;
  const changeFileStatus = (fileStatus: FileStatus) => {
    setFileStatus(fileStatus);
  };
  let retryCount = 0;
  const addFileDetails = (fileValue: File) => {
    setFileDetails(fileValue);
  };

  const addErrorData = (errorData: any) => {
    setErrorData(errorData);
  };

  const mapErrorStateAdmin = (jobData: any, index: any) => {
    return {
      "S#": apiErrorList.length + index + 1,
      "First Name": jobData.user.given_name,
      "Last Name": jobData.user.family_name,
      "User ID": jobData.user.username,
      "Phone number": Utility.convertPhoneNumber(
        jobData.user.app_metadata.phone_number
      ),
      "Date of birth": Utility.formatDate(jobData.user.user_metadata.birthdate),
      State: jobData.user.user_metadata.address.region,
      Districts: jobData.user.user_metadata.address.locality,
      errorMessage: jobData.errors[0].message,
    };
  };

  const mapErrorAsha = (jobData: any, index: any) => {
    return {
      "S#": apiErrorList.length + index + 1,
      "First Name": jobData.user.given_name,
      "Last Name": jobData.user.family_name,
      "ASHA ID": Utility.userNameConvert(jobData.user.username),
      "Phone number": Utility.convertPhoneNumber(
        jobData.user.app_metadata.phone_number
      ),
      "Date of birth": Utility.formatDate(jobData.user.user_metadata.birthdate),
      /*       "Marital status":
        jobData.user.user_metadata.organizations.EODB.marital_status,
      "Husband Name":
        jobData.user.user_metadata.organizations.EODB.husband_name, */
      "Village/Slum": jobData.user.user_metadata.address.street_address,
      "Sub Center": jobData.user.user_metadata.organizations.EODB.sub_center,
      "UPHC/PHC": jobData.user.user_metadata.organizations.EODB.uphcPhc,
      "District/Block": jobData.user.user_metadata.address.locality,
      State: jobData.user.user_metadata.address.region,
      "Pin code": jobData.user.user_metadata.address.postal_code,
      errorMessage: jobData.errors[0].message,
    };
  };

  const auth0toCSVJsonData = (failedJobList: any) => {
    let mappedJsonList = [];
    for (let i = 0; i < failedJobList.length; i++) {
      if (userId === "admin") {
        const mappedErrorStateAdminData = mapErrorStateAdmin(
          failedJobList[i],
          i
        );
        mappedJsonList.push(mappedErrorStateAdminData);
      } else if (userId === "asha") {
        const mappedAshaErrorData = mapErrorAsha(failedJobList[i], i);
        mappedJsonList.push(mappedAshaErrorData);
      }
    }
    return mappedJsonList;
  };

  const checkJobStatus = async () => {
    try {
      const updatedURL = API.USERS_GET_JOB_STATUS.replace(
        ":jobId",
        bulkJobDetails.id
      );
      const jobStatus = await httpService.callAPI(
        updatedURL,
        "GET",
        {},
        "auth0"
      );
      return jobStatus;
    } catch (error) {
      dispatch(errorUpdate({ isError: true, error: error }));
    }
  };

  const getErrorJobStatus = async () => {
    try {
      const updatedURL = API.USERS_GET_JOB_ERROR.replace(
        ":jobId",
        bulkJobDetails.id
      );
      const failedJobList: any = await httpService.callAPI(
        updatedURL,
        "GET",
        {},
        "auth0"
      );
      const finalJsonData = auth0toCSVJsonData(failedJobList);
      setAuth0ErrorList(finalJsonData);
      setFileStatus(FileStatus.ERROR);
      const errorObj = {
        title_key: "error.error",
        entryDetailsFailed: "error.entries_failed",
        jsonDataLength: finalJsonData?.length + apiErrorList?.length,
        bulkJobDetails: bulkJobDetails?.summary?.total + apiErrorList?.length,
        message: "Download file to view the errored entries",
        message_key: "error.download_error_file",
        actionButtonType: ErrorButtonActionType.DOWNLOAD,
      };
      addErrorData(errorObj);
    } catch (error) {
      dispatch(errorUpdate({ isError: true, error: error }));
    }
  };

  const callBulkSMS = async () => {
    try {
      const roleValue = userId === "asha" ? "Asha" : "State Admin";
      const bulkSMSResult = await httpService.callBulkSMS(
        API.USER_BULK_SMS,
        "POST",
        {
          userRole: roleValue,
          smsType: "user-onboarding",
        }
      );
    } catch (error) {
      dispatch(errorUpdate({ isError: true, error: error }));
    }
  };

  const handleJobStatus = async () => {
    const resp: any = await checkJobStatus();
    if (resp.status === "completed") {
      setBulkJobDetails(resp);
    } else {
      if (retryCount < 5) {
        handleJobStatus();
      } else {
        const errorObj = {
          message: "Something went wrong! Please refresh and try again.",
          message_key: "error.component_error",
        };
        addErrorData(errorObj);
      }
    }
    retryCount++;
  };

  useEffect(() => {
    if (bulkJobDetails?.status === "pending") {
      setTimeout(async () => {
        handleJobStatus();
      }, 5000);
    } else if (bulkJobDetails.status === "completed") {
      if (bulkJobDetails?.summary?.failed > 0 || apiErrorList.length > 0) {
        getErrorJobStatus();
      } else if (
        bulkJobDetails?.summary?.failed === 0 &&
        apiErrorList.length === 0
      ) {
        changeFileStatus(FileStatus.COMPLETED);
      }

      if (Utility.env?.REACT_APP_SEND_SMS) {
        callBulkSMS();
      }
    }
  }, [bulkJobDetails]);

  const handelFileUpload = async (fileInfo: File[]) => {
    try {
      if (fileInfo.length > 1) {
        const errorObj = {
          isCustom: true,
          title: "Please try uploading one file at a time!",
          title_key: "upload_one_file",
          message: "Select a .CSV file to upload",
          message_key: "select_csv_file",
          actionButtonType: ErrorButtonActionType.SELECTFILE,
        };
        throw errorObj;
      }

      const allowedExtensions = /(\.csv)$/i;
      if (!allowedExtensions.exec(fileInfo[0].name)) {
        const errorObj = {
          isCustom: true,
          title: "Error due to file format!",
          title_key: "error.invalid_file_format",
          message: "Please upload a valid(.CSV) file format",
          message_key: "error.upload_valid_csv",
          actionButtonType: ErrorButtonActionType.SELECTFILE,
        };
        throw errorObj;
      }

      addFileDetails(fileInfo[0]);
      changeFileStatus(FileStatus.SUBMIT);
    } catch (error: any) {
      console.log("Error", error);

      if (error?.isCustom) {
        addErrorData(error);
      } else {
        //Need to create custom error message obj once api integration is ready.
        const errorObj = {
          title: "An error has occurred, Please try again" || error?.title,
          title_key: "error.error_occured",
          message: "Please select a valid .CSV file." || error?.message,
          message_key: "select_csv_file",
          actionButtonType: ErrorButtonActionType.SELECTFILE,
        };
        addErrorData(errorObj);
      }
      changeFileStatus(FileStatus.ERROR);
    }
  };

  const handleFileSubmit = async () => {
    const csvFile: any = fileDetails;
    let formData = new FormData();
    formData.append("userAddType", userId);
    formData.append("csvFiles", csvFile, csvFile.name);
    formData.append("accessToken", AuthService.instance.rawAuthToken);
    if (userId == "asha") {
      formData.append("state", state);
    }
    try {
      changeFileStatus(FileStatus.INPROGRESS);
      const bulkUploadResult = await httpService.callBulkAPI(
        API.USERS_BULK_IMPORT,
        "POST",
        formData
      );

      setApiErrorList(bulkUploadResult.errorList);
      const updatedBulkResponse = { ...bulkUploadResult };
      delete updatedBulkResponse["errorList"];
      setBulkJobDetails(updatedBulkResponse);
    } catch (error: any) {
      changeFileStatus(FileStatus.ERROR);
      const errorObj = {
        title: "Error due to invalid column names!" || error?.title,
        title_key: "error.error_occured",
        message: "Please select a valid .CSV file." || error?.message,
        message_key: "select_csv_file",
        actionButtonType: ErrorButtonActionType.SELECTFILE,
      };
      addErrorData(errorObj);
      dispatch(errorUpdate({ isError: true, error: error }));
    }
  };

  const renderUploadComponent = (currentStateValue: FileStatus) => {
    switch (currentStateValue) {
      case FileStatus.INPROGRESS:
        return (
          <UploadInProgress
            changeFileStatus={changeFileStatus}
            fileDetails={fileDetails}
            userId={userId}
            bulkJobDetails={bulkJobDetails}
          />
        );
      case FileStatus.COMPLETED:
        return <UploadCSVSuccess changeFileStatus={changeFileStatus} />;
      case FileStatus.ERROR:
        return (
          <UploadCSVError
            errorData={errorData}
            setFileStatus={setFileStatus}
            handelFileUpload={handelFileUpload}
            errorList={[...apiErrorList, ...auth0ErrorList]}
            addType={userId}
          />
        );
      case FileStatus.SUBMIT:
        return (
          <UploadCSVSubmit
            fileDetails={fileDetails}
            setFileStatus={setFileStatus}
            userId={userId}
            handleFileSubmit={handleFileSubmit}
            handelFileUpload={handelFileUpload}
          />
        );
      case FileStatus.INIT:
      default:
        return <UploadCSV handelFileUpload={handelFileUpload} />;
    }
  };

  useEffect(() => {
    const checkIntrospect = async () => {
      const inrospectUrl =
        process.env.REACT_APP_PCPO_BACK_END_HEALTH_API + "/introspect";
      const authToken = { token: AuthService.instance.rawAuthToken };
      try {
        const introspectToken = await httpService.callIntrospect(
          inrospectUrl,
          "POST",
          authToken
        );
        if (introspectToken.active === true) {
          dispatch(
            updateBreadcrum({
              routeHistory: [
                {
                  label: `Add ${userId}`,
                  label_key: `add_${userId?.toLowerCase()}`,
                  path: PAGE.ADD_USERS,
                  id: "add_admin",
                  value: "",
                },
              ],
              display: true,
            })
          );
        } else {
          throw {
            status: 400,
            statusCode: "introspectCheck",
            message: "introspect is active",
          };
        }
      } catch (error) {
        dispatch(errorUpdate({ isError: true, error: error }));
      }
    };
    checkIntrospect();
  }, []);

  return (
    <>
      <div className="bg-light-gray">
        <div className="container">
          <div className="addUserTitle" data-testid="addUserTitleTest">
            <Trans i18nKey={`add_${userId?.toLowerCase()}`} />
          </div>
        </div>
      </div>
      <div className="container">
        <div className="csvTitle">
          <Trans i18nKey={"upload_csv"} />
        </div>
      </div>
      <div className="container csvContainer text-center">
        {renderUploadComponent(fileStatus)}
      </div>
    </>
  );
};

export default AddUsers;
